<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1" id="title"><a id="page_3"></a>F<span class="small">OR</span> N<span class="small">OBODY</span>’<span class="small">S</span> E<span class="small">YES</span> O<span class="small">NLY</span></h1>
<p class="subtitle"><em>M<span class="small">ISSING</span> G<span class="small">OVERNMENT</span> F<span class="small">ILES AND</span><br/>H<span class="small">IDDEN</span> A<span class="small">RCHIVES</span> T<span class="small">HAT</span> D<span class="small">OCUMENT<br/>THE</span> T<span class="small">RUTH</span> B<span class="small">EHIND THE</span> M<span class="small">OST</span><br/>E<span class="small">NDURING</span> C<span class="small">ONSPIRACY</span> T<span class="small">HEORIES</span></em></p>
<p class="author">N<span class="small">ICK</span> R<span class="small">EDFERN</span></p>
<p class="pub"><img alt="Images" src="images/f0003-01.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?7e0ec346